import BaseView from '@/store/modules/components/BaseView'

export default class DocxTemplatesView extends BaseView {
    constructor() {
        super('docxTemplates')
    }
}
